import EventBrackets from './EventBrackets';

export default EventBrackets